import { activityFetch as fetch } from '../feedback/requestActivity'
import React, { useEffect, useState } from "react";
import {reqGet} from '../../Service';
import {reqPost} from '../../Service';
import styled from 'styled-components';
import { Monitor, Server, ExternalLink, Circle, Settings, Pencil, Check, Terminal as TerminalIcon, Trash2 } from 'lucide-react';
import { useLocation, useNavigate } from "react-router-dom";
import AddAccount from "../../screen/AddAccountModal";
import './style.css';
import { makeRdpRequest } from '../../rdpConnection';

const StyledCard = styled.div`
  &&{width:100%;min-width:0;max-width:none;height:auto;min-height:216px;border:1px solid #dce6df;border-radius:11px;background:#fff;box-shadow:none;overflow:visible;transition:border-color .2s;}
  &&:hover{border-color:#9dbdaa;box-shadow:0 3px 12px #244d3510;}
  && input{min-width:0;max-width:100%;box-sizing:border-box;padding:6px 8px;}
  position: relative;
  overflow: hidden;
  background: linear-gradient(to bottom right, #fafafa, #f5f5f5);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
  border-radius: 8px;
  width: 100%;          // 추가
  min-width: 200px;     // 추가
  max-width: 350px;     // 추가
  height: 196px;        // 컴팩트하게 축소

  &:hover {
    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.15);
  }
`;

const CardContent = styled.div`
  &&{padding:20px;min-width:0;min-height:216px;gap:12px;}
  padding: 16px 18px;     // 컴팩트
  display: flex;          // 추가
  flex-direction: column; // 추가
  height: 100%;
  box-sizing: border-box;
`;

const InfoGrid = styled.div`
  &&{gap:6px;margin-bottom:0;min-width:0;align-content:start;}
  display: grid;
  gap: 6px;
  margin-bottom: ${props => props.editMode ? '10px' : '14px'};
  flex: 1;
`;

const CardHeader = styled.div`
  &&{top:12px;right:12px;gap:3px;z-index:1;}
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const IconButton = styled.button`
  &&{width:28px;height:28px;opacity:1;color:#84998b;border-radius:5px;}
  &&:hover,&&:focus-visible{background:#eff5ef;color:#286b4c;}
  height: 32px;
  width: 32px;
  border: none;
  background: transparent;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;

  ${StyledCard}:hover & {
    opacity: 1;
  }
`;

const HeaderSection = styled.div`
  &&{padding-right:82px;min-width:0;margin-bottom:0;}
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 6px;
`;

const IconContainer = styled.div`
  &&{background:#eef5ef;color:#4c8265;border-radius:8px;padding:8px;flex-shrink:0;}
  && svg{color:inherit;}
  padding: 8px;
  background-color: rgba(0, 0, 255, 0.1);
  border-radius: 8px;
`;

const TitleSection = styled.div`
  &&{min-width:0;gap:10px;padding:0;width:100%;}
  &&>div:last-child{min-width:0;flex:1;}
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 4px 0px;
`;

const Title = styled.label`
  &&{display:block;font-size:14px;line-height:1.5;color:#294b39;overflow-wrap:anywhere;font-weight:600;}
  font-weight: 600;
  font-size: 1.125rem;
`;

const Domain = styled.p`
  &&{font-size:11px;color:#859789;overflow-wrap:anywhere;line-height:1.6;margin-top:4px;}
  font-size: 0.875rem;
  color: #666;
  text-align:left;
  margin: 2px 0px;
`;


const InfoItem = styled.div`
  &&{font-size:12px;line-height:1.6;min-width:0;overflow-wrap:anywhere;color:#829085;}
  && svg{flex-shrink:0;}
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.875rem;
`;

const ActionButtons = styled.div`
  &&{gap:8px;padding-top:8px;min-width:0;}
  display: flex;
  gap: 8px;
  margin-top: auto;
`;

const ConnectButton = styled.button`
  &&{background:#24765a;border-radius:7px;min-height:36px;transform:none;font-size:12px;padding:8px 12px;min-width:0;}
  &&:hover{background:#1b6249;}
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  background: #0066ff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transform: translateY(4px);
  transition: all 0.3s;

  ${StyledCard}:hover & {
    transform: translateY(0);
  }

  &:hover {
    background: #0052cc;
  }
`;

const SettingsButton = styled.button`
  &&{border-color:#dfe8e0;border-radius:7px;color:#78937e;transform:none;width:36px;min-height:36px;flex-shrink:0;}
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border: 1px solid #e0e0e0;
  background: white;
  border-radius: 4px;
  cursor: pointer;
  transform: translateY(4px);
  transition: all 0.3s;

  ${StyledCard}:hover & {
    transform: translateY(0);
  }
`;

export default function RemoteCard({
  status = "unknown",
  title,
  domain,
  port,
  info,
  type,
  infra_id,
  defaultAccount,
  defaults,
  flag,
  refresh,
  remove,
  os_type,
  console_proto,
  initialEditMode = false // 초기 editMode 값
 }) {

 // 콘솔 프로토콜 결정: console_proto 우선, 없으면 os_type 으로 유추
 const isSshHost = console_proto === 'ssh'
   || (!console_proto && os_type && os_type !== 'windows');

 const [,setActiveWindow] = useState(null);
 const [,set_infraList] = useState([]);
 const [isToggle, setIsToggle] = useState(false);
 const [,set_selectedOption] = useState();
 const [editMode, setEditMode] = useState(initialEditMode); // initialEditMode로 초기화
 const [editMode_InputDomain, set_editMode_InputDomain] = useState(domain);
 const [editMode_InputPort, set_editMode_InputPort] = useState(port);
 const [editMode_InputInfo, set_editMode_InputInfo] = useState(info);
 const [editMode_InputTitle, set_editMode_InputTitle] = useState(title);
 const [,set_editMode_InputDefault] = useState(defaults);
 const [editMode_InputDefaultAccount, set_editMode_InputDefaultAccount] = useState(defaultAccount);
 const [showModal, setShowModal] = useState(false);
 const history = useLocation();
 const navigate = useNavigate();
 const [selectedCredential, setSelectedCredential] = useState(null);

 // 새로운 스타일 컴포넌트 추가
const Modal = styled.div`
position: fixed;
top: 50%;
left: 50%;
transform: translate(-50%, -50%);
background: white;
padding: 20px;
border-radius: 8px;
box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
z-index: 1000;
width: 300px;
`;

const Overlay = styled.div`
position: fixed;
top: 0;
left: 0;
right: 0;
bottom: 0;
background: rgba(0, 0, 0, 0.5);
z-index: 999;
`;
  
const EditableInput = styled.input`
  background: transparent;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  transition: border-color 0.2s;
  width: ${props => props.width || '70%'};
  
  &:focus {
    outline: none;
    border-color: #0066ff;
  }

  // 타이틀 input
  ${props => props.isTitle && `
    font-size: 1.125rem;
    font-weight: 600;
    margin:2px 0px;
  `}

  // 도메인 input
  ${props => props.isDomain && `
    font-size: 0.875rem;
    color: #666;
    text-align:left;
    margin:2px 0px;
  `}

  // 포트 input
  ${props => props.isPort && `
    width: 60px;
    padding: 2px 4px;
    margin-left: 4px;
  `}

  // 설명 input
  ${props => props.isInfo && `
    color: #666;
    font-size: 0.875rem;
  `}
`;

  useEffect(()=>{ ShowInfraList(infra_id);  },[]);
  
  const ShowInfraList=(infra_id)=>{
    reqGet('api/getInfraList',{infra_id:infra_id},(result,param)=>{ 
      console.log('파라미터:'+JSON.stringify(param));
      set_infraList(result);
    });
  }


  /**생성 수정 */
  const modifyRemote = (windowId) => {
    if(editMode){
      if(flag === 'I')
        reqPost('/api/hostAdd',
      {type:type, title:editMode_InputTitle,domain:editMode_InputDomain,
        port:editMode_InputPort,info:editMode_InputInfo,
        defaultAccount:editMode_InputDefaultAccount,id:infra_id},(res)=>alert('저장완료'+res ));
      else 
      reqPost('/api/hostUpdate',
        {type:type,title:editMode_InputTitle,domain:editMode_InputDomain,
        port:editMode_InputPort,info:editMode_InputInfo,
        defaultAccount:editMode_InputDefaultAccount,id:infra_id},
        (res)=>refresh(alert("수정완료"))
      );
      refresh();
    }
    setEditMode(!editMode);
  };
   // 모달 토글 핸들러
   const handleSettingsClick = () => {
    setShowModal(true);
  };
  useEffect(() => {
    ShowInfraList(infra_id);  
    set_infraList([]);
    setIsToggle(false);
    set_selectedOption();
    setActiveWindow(null);
    setEditMode(editMode);
    set_editMode_InputDomain(domain);
    set_editMode_InputPort(port);
    set_editMode_InputInfo(info);
    set_editMode_InputTitle(title);
    set_editMode_InputDefault(defaults);
    set_editMode_InputDefaultAccount(defaultAccount);
  }, [type, infra_id,  editMode, domain, port, info, title, defaults, defaultAccount]);

  const handleApplyCredential = (credential) => {
    setSelectedCredential(credential);
    setShowModal(false);
  };

    const openSshConsole = () => {
      const path = selectedCredential?.accounts_id
        ? `/console/${infra_id}?accounts_id=${selectedCredential.accounts_id}`
        : `/console/${infra_id}`;
      const w = Math.min(1100, window.screen.availWidth - 100);
      const h = Math.min(700, window.screen.availHeight - 100);
      const left = Math.max(0, (window.screen.availWidth - w) / 2);
      const top = Math.max(0, (window.screen.availHeight - h) / 2);
      window.open(
        path,
        `skynet-console-${infra_id}`,
        `popup=yes,noopener,width=${w},height=${h},left=${left},top=${top}`
      );
    };

    const handleConnect = async () => {
      // SSH 호스트면 브라우저 콘솔, 그 외엔 mstsc(RDP)
      if (isSshHost) {
        return openSshConsole();
      }

      try {
        const data = JSON.stringify(makeRdpRequest(domain, port, selectedCredential));

        await fetch('http://localhost:50814', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: data
        });
      } catch (error) {
        console.error('RDP 연결 오류:', error);
      }
     };
 
  return (
    <StyledCard className="compute-host-card" aria-label={`${title} 서버`}>
      <CardHeader>
        <IconButton onClick={modifyRemote} title={editMode ? '저장' : '수정'}>
          {editMode ? <Check size={16} /> : <Pencil size={16} />}
        </IconButton>
        {infra_id && remove && (
          <IconButton
            onClick={() => remove(infra_id, title)}
            title="호스트 삭제"
            style={{ color: '#dc2626' }}
          >
            <Trash2 size={16} />
          </IconButton>
        )}
        <Circle
          aria-label={status === 'active' ? '접속됨' : '접속 미확인'}
          size={12}
          fill={status === "active" ? "#22c55e" : "#9ca3af"}
        />
      </CardHeader>
      {showModal && (
        <>
          <Overlay onClick={() => setShowModal(false)} />
          <Modal>
            <AddAccount 
              type={type} 
              infra_id={infra_id} 
              handleApplyCredential={handleApplyCredential}
              onClose={() => setShowModal(false)}
            />
          </Modal>
        </>
      )}
      <CardContent>
        {editMode ? (
          // 수정 모드 UI
          <>
          <HeaderSection>
            <TitleSection>
              <IconContainer>
                <Server size={20} color="#0066ff" />
              </IconContainer>
              <div style={{textAlign:"left"}}>
              <div style={{textAlign:"left"}}>
              <input aria-label="서버 이름"
                type="text"
                style={{
                  background: "transparent",
                  border: "1px solid #e5e7eb",
                  borderRadius: "4px",
                  fontSize: "1.125rem",
                  fontWeight: "600",
                  margin: "2px 0px"
                }}
                value={editMode_InputTitle}
                onChange={(e) => set_editMode_InputTitle(e.target.value)}
              />
              <input aria-label="서버 주소"
                type="text"
                style={{
                  background: "transparent",
                  border: "1px solid #e5e7eb",
                  borderRadius: "4px",
                  fontSize: "0.875rem",
                  color: "#666",
                  textAlign: "left",
                  margin: "2px 0px"
                }}
                value={editMode_InputDomain}
                onChange={(e) => set_editMode_InputDomain(e.target.value)}
              />
            </div>
              </div>
            </TitleSection>
          </HeaderSection>

          <InfoGrid editMode={editMode}>
            <InfoItem>
              <Monitor size={16} color="#666" />
              <span style={{ color: '#666' }}>Port:</span>
              <input
      type="text" aria-label="서버 포트"
      style={{
        background: "transparent",
        border: "1px solid #e5e7eb",
        borderRadius: "4px",
        width: "60px",
        padding: "2px 4px",
        marginLeft: "4px"
      }}
      value={editMode_InputPort}
      onChange={(e) => set_editMode_InputPort(e.target.value)}
    />
            </InfoItem>
            <InfoItem>
            <input
      type="text" aria-label="서버 설명"
      style={{
        background: "transparent",
        border: "1px solid #e5e7eb",
        borderRadius: "4px",
        color: "#666",
        fontSize: "0.875rem",
        width: "70%"
      }}
      value={editMode_InputInfo}
      onChange={(e) => set_editMode_InputInfo(e.target.value)}
    />
            </InfoItem>
          </InfoGrid>
        </>
        ) : (
          // 일반 모드 UI (기존 코드)
          <>
            <HeaderSection>
              <TitleSection>
                <IconContainer>
                  <Server size={20} color="#0066ff" />
                </IconContainer>
                <div>
                  <Title>{title}</Title>
                  <Domain>{domain}</Domain>
                </div>
              </TitleSection>
            </HeaderSection>
  
            <InfoGrid editMode={editMode}>
              <InfoItem>
                <Monitor size={16} color="#666" />
                <span style={{ color: '#666' }}>Port:</span>
                <span style={{ fontWeight: 500 }}>{port}</span>
              </InfoItem>
              <InfoItem style={{ color: '#666' }}>{info}</InfoItem>
            </InfoGrid>
          </>
        )}
  
        <ActionButtons>
          <ConnectButton onClick={()=>handleConnect()} title={isSshHost ? 'SSH 브라우저 콘솔' : 'RDP (mstsc)'}>
            {isSshHost ? <TerminalIcon size={16} style={{ marginRight: '8px' }} /> : <ExternalLink size={16} style={{ marginRight: '8px' }} />}
            {isSshHost ? 'SSH 콘솔' : '연결하기'}
          </ConnectButton>
          <SettingsButton onClick={handleSettingsClick} aria-label="접속 계정 설정">
            <Settings size={16} />
          </SettingsButton>
        </ActionButtons>
      </CardContent>
    </StyledCard>
  );
}
